import { IVideoCompliance } from "@shared/lib/types/drafting";
import { useQuery } from "@tanstack/react-query";
import { generateMediaAssetsKey } from "../../constants";
import { BriefService } from "../../services/brief.service";

export default function useGetMediaAssets(data: IVideoCompliance) {
  const {
    data: mediaAssetsInfo,
    isFetching: isMediaAssetsFetching,
    error: mediaAssetsError,
    isSuccess: isMediaAssetsSuccess,
    isFetched: isMediaAssetsFetched,
    refetch: mediaAssetsRefetch,
  } = useQuery({
    queryFn: () => BriefService.getMediaAssets(data),
    queryKey: [...generateMediaAssetsKey(data)],
    refetchInterval: (query) => {
      const complianceStatus = query?.state?.data?.data?.complianceCheckStatus;
      const feedbackStatus = query?.state?.data?.data?.feedbackSummaryStatus;
      const transcriptionStatus = query?.state?.data?.data?.transcriptionStatus;

      const shouldPollCompliance = complianceStatus === "Pending";

      const shouldPollFeedback = feedbackStatus === "Pending";
      const shouldPollTranscription = transcriptionStatus === "Pending";

      return shouldPollCompliance ||
        shouldPollFeedback ||
        shouldPollTranscription
        ? 5000
        : undefined;
    },
    refetchIntervalInBackground: true,
    enabled:
      !!data.draftingId && !!data.draftingVersionId && !!data.mediaAssetId,
    placeholderData: (prev) => prev,
  });

  return {
    mediaAssetsError,
    mediaAssetsInfo,
    isMediaAssetsFetching,
    isMediaAssetsSuccess,
    isMediaAssetsFetched,
    mediaAssetsRefetch,
  };
}
